//获取中台地址
  export function getYeahMediaUrl() {
    let host;
    if (
      // window.location.protocol === "https:" &&
      window.location.host.includes("cyberklick")
    ) {
      host = "https://business.cyberklick.com.cn/";
    } else if (window.location.host.includes("dev")) {
      host = "http://dev.business.yeahmobi.com/";
    } else {
      host = "http://test.business.yeahmobi.com/";
    }
    return host;
  }
  // 获取登录地址
  export function getLoginUrl() {
    return `${getYeahMediaUrl()}login`;
  }

  // 获取不需要登录地址
  export function getNoToken() {
    return ['noPermissionView'];
  }